import styled from "@emotion/styled";
import Img from "gatsby-image";

export default styled(Img)`
  border-radius: 12px;
  overflow: hidden;
`;
